import { ErrorBoundary } from "react-error-boundary";
import { Navigate, useLocation } from "react-router";

import { useCurrentUser } from "Auth/Hooks/useCurrentUser";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";

type UnauthenticatedRouteProps = {};

export const UnauthenticatedRoute = ({
  children,
}: React.PropsWithChildren<UnauthenticatedRouteProps>): React.ReactNode => {
  const { isAuthenticated, isLoading } = useCurrentUser();
  const location = useLocation();

  if (isLoading) return <div />;

  if (isAuthenticated) {
    const redirectTo =
      (location.state as { from?: string })?.from ??
      AppRouting.Dashboard.path();
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <ErrorBoundary FallbackComponent={ApplicationErrorPage}>
      {children}
    </ErrorBoundary>
  );
};
